import { useToast } from "@/hooks/use-toast";
import { type JSX, useCallback } from "react";
import { ToastAction } from "../../ui/toast";
import { PAYMENT_ERROR_INSUFFICIENT_BALANCE, PAYMENT_ERROR_SWITCH_CHAIN } from "../errors";
import { useStore } from "../store";

type ErrorMessages = {
  [PAYMENT_ERROR_INSUFFICIENT_BALANCE]: JSX.Element;
  [PAYMENT_ERROR_SWITCH_CHAIN]: JSX.Element;
};

const TOAST_ACTIONS: ErrorMessages = {
  [PAYMENT_ERROR_INSUFFICIENT_BALANCE]: (
    <ToastAction altText="Buy $KOLZ">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://app.uniswap.org/explore/tokens/base/0x50ce4129ca261ccde4eb100c170843c2936bc11b"
      >
        Buy $KOLZ
      </a>
    </ToastAction>
  ),
  [PAYMENT_ERROR_SWITCH_CHAIN]: (
    <ToastAction altText="Reload the page" onClick={() => window.location.reload()}>
      Reload the page
    </ToastAction>
  ),
};

export default function useHandleErrors() {
  const { setIsProcessing } = useStore();
  const { toast } = useToast();

  const handleError = useCallback(
    (error: unknown, customMessage: string | null = null) => {
      let errorMessage = "";
      if (error instanceof Error) {
        console.error(error.message);
        errorMessage = error.message;
        // TODO: send logs to sentry
      } else {
        console.error(error);
        // TODO: send logs to sentry
      }
      if (customMessage) console.error(customMessage);

      setIsProcessing(false);
      const description =
        customMessage || errorMessage || "An error occurred while processing the payment. Please try again.";
      const action = TOAST_ACTIONS[description as keyof ErrorMessages];
      toast({
        title: "Oooops",
        description,
        variant: "destructive",
        ...(action && { action }),
      });
    },
    [setIsProcessing, toast],
  );

  return { handleError };
}
